<style scoped>
  .smileys-wrapper {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
  }

  .smiley {
    font-size: 2em;
    font-family: "Noto Color Emoji", "Apple Color Emoji", "Segoe UI Emoji", Times, Symbola, Aegyptus, Code2000, Code2001, Code2002, Musica, serif, LastResort!important;
  }

  .disabled {
    cursor: not-allowed;
    filter: grayscale(100%);
  }
</style>

<template>
  <div
    v-if="room && room.smileys_enabled"
    class="smileys-wrapper pa-3"
  >
        <div
          v-for="smiley in smileys"
          :key="smiley"
          v-html="smiley"
          class="smiley"
          :class="{ disabled }"
          @click="() => sendSmiley(smiley)"
        />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  data () {
    return {
      disabled: false
    }
  },
  computed: {
    ...mapGetters({
      roomId: 'common/roomId',
      room: 'common/room',
    }),
    ...mapState({
      smileys: state => state.common.smileys.allowed_array,
      rooms: state => state.common.rooms,
    }),
    isMobile () {
      return this.$vuetify.breakpoint.mobile
    },
  },
  methods: {
    sendSmiley(code) {
      if(!this.disabled) {
        const room_id = this.roomId
        this.disabled = true
        setTimeout(() => this.disabled = false, 10000)
        axios.post('/smileys', { code, room_id })
      }
    },
  },
}
</script>
